<template>
  <p
    class="word"
    :style="{
      left: wordPosition.left + 'px',
      top: wordPosition.top + 'px'
    }"
  >
    <span> {{ wordPosition.text }}</span>
  </p>
</template>
<script>
export default {
  props: ['item'],

  computed: {
    wordPosition() {
      let words = {
        left: this.item.left,
        top: this.item.top,
        width: this.item.width,
        text: this.item.text
      };
      return words;
    }
  }
};
</script>
